import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-admin-event',
  templateUrl: './admin-event.component.html',
  styleUrls: ['./admin-event.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminEventComponent implements OnInit {

  eventForm: FormGroup;
  public eventDetails: any;
  public eventsList: Array<any> = [];

  constructor(private formBuilder: FormBuilder, private _ref: ChangeDetectorRef, private _adminService: AdminService) {
    this.eventForm = this.formBuilder.group({
      eventTitle: ['', [Validators.required, Validators.minLength(3)]],
      eventSubTitle: ['', [Validators.required, Validators.minLength(3)]],
      eventAmount: ['', [Validators.required, Validators.minLength(3)]],
      eventDescription: ['', [Validators.required, Validators.minLength(3)]],
      eventOrganizer: ['', [Validators.required, Validators.minLength(3)]],
      eventImagePath: ['', []],
      eventLimit: ['', [Validators.required, Validators.minLength(3)]],
      eventDate: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  ngOnInit() {
    this.getAllEvents();
  }

  getAllEvents() {
    this._adminService.getAllEvents().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.eventsList = response;
        else this.eventsList = [];

        this.eventDetails = null;
        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.eventsList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  getEventById(eventId: any) {
    if (!eventId) {
      alert("Valid event not selected for edit.");
      return;
    } else {
      this._adminService.getEventById(eventId).subscribe({
        next: (response: any) => {
          if (response) this.eventDetails = response;
          else this.eventDetails = null;

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          this.eventDetails = null;
          this._ref.markForCheck();
          console.log(error);
        },
      });
    }
  }

  clickOnSubmit() {
    if (this.eventDetails && this.eventDetails != null) {
      this.updateAdminEvent(this.eventDetails?._id);
    } else {
      this.saveAdminEvent();
    }
  }

  saveAdminEvent() {
    if (!this.eventForm.valid) {
      alert("Event is not have valid details.");
      this.eventForm.markAllAsTouched();
      return;
    } else {
      this._adminService.postEvent(this.eventForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Event insert successful.");
            this.eventForm.reset();
            this.getAllEvents();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  updateAdminEvent(eventId: any) {
    if (!eventId && !this.eventForm.valid) {
      alert("Event is not have valid details.");
      this.eventForm.markAllAsTouched();
      return;
    } else {
      this._adminService.putEvent(eventId, this.eventForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Event update successful.");
            this.eventForm.reset();
            this.getAllEvents();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  deleteAdminEvent(eventId: any) {
    if (!eventId) {
      alert("Valid event not selected for delete.");
      return;
    } else {
      this._adminService.deleteEvent(eventId).subscribe({
        next: (response: any) => {
          if (response) {
            alert("Event delete successful.");
            this.eventForm.reset();
            this.getAllEvents();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  clearEvent() {
    this.eventForm.reset();
  }
}
